/**
 * <s-wishlist-count> — badge showing how many products are saved.
 */
import { getItems, onChange } from '@theme/wishlist-store';

class SWishlistCount extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.#render();
    onChange(() => this.#render(), this.#ac.signal);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #render() {
    const count = getItems().length;
    this.textContent = count > 0 ? String(count) : '';
    this.hidden = count === 0;
  }
}

if (!customElements.get('s-wishlist-count')) customElements.define('s-wishlist-count', SWishlistCount);
